import { useQuery } from '@tanstack/react-query';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '@/backend/lib/firebase';
import { RoomType } from '@/shared/types';
import { isPublished } from '@/backend/lib/residenceUtils';

export const fetchRoomTypesByResidenceId = async (residenceId: string): Promise<RoomType[]> => {
  const roomTypesRef = collection(db, 'roomTypes');
  const q = query(roomTypesRef, where('residenceId', '==', residenceId));
  const snapshot = await getDocs(q);
  const rooms = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })) as RoomType[];
  // Drafts are incomplete, not-yet-public rooms — exclude them so they can't be
  // booked, contracted, or listed. Legacy docs with no `status` count as published.
  return rooms.filter(isPublished);
};

export const useRoomTypes = (residenceId?: string) => {
  return useQuery({
    queryKey: ['roomTypes', residenceId],
    queryFn: () => residenceId ? fetchRoomTypesByResidenceId(residenceId) : Promise.resolve([]),
    enabled: !!residenceId
  });
};
